<div class="d-flex flex-column gap-3 p-4 h-100">
  <header class="d-flex flex-wrap row-gap-3">
    <h1 class="col-md-4 col-12 m-0 p-0">Kalender</h1>
    <div class="d-flex justify-content-md-center gap-2 col-md-4 col-12">
      <button (click)="setCalendarType(CalendarType.WEEK)" class="btn btn-progreso">{{ 'week' | label: 'general' | async | titlecase }}</button>
      <button (click)="setCalendarType(CalendarType.MONTH)" class="btn btn-progreso">{{ 'month' | label: 'general' | async | titlecase }}</button>
      <button (click)="setCalendarType(CalendarType.YEAR)" class="btn btn-progreso">{{ 'year' | label: 'general' | async | titlecase }}</button>
    </div>
    <div class="d-flex justify-content-md-end gap-2 col-md-4 col-12">
      <button (click)="stepToPreviousDate()" class="btn btn-progreso"><</button>
      <span class="d-flex align-items-center fw-bold fs-5">
        <ng-container [ngSwitch]="calendarType">
          <ng-container *ngSwitchCase="CalendarType.WEEK">
            <!--2 Februari - 8 Februari, 20XX-->
            {{ firstDayOfWeek | employeeDate: 'd MMMM' | async }} - {{ lastDayOfWeek | employeeDate: 'd MMMM, y' | async }}
          </ng-container>
          <ng-container *ngSwitchCase="CalendarType.MONTH">
            {{ date | employeeDate: 'MMMM y' | async }}
          </ng-container>
          <ng-container *ngSwitchCase="CalendarType.YEAR">
            {{ date | employeeDate: 'y' | async }}
          </ng-container>
        </ng-container>
      </span>
      <button (click)="stepToNextDate()" class="btn btn-progreso">></button>
      <button (click)="stepToToday()" class="btn btn-progreso">{{ 'today' | label: 'general' | async }}</button>
    </div>
  </header>

  <ng-container [ngSwitch]="calendarType">
    <!--WEEK-->
    <ng-container *ngSwitchCase="CalendarType.WEEK">
      <app-calendar-week #weekCalendar [date]="date" [eventHandler]="eventHandler" [dayTemplate]="weekDayTemplate" [settings]="weekSettings" (eventClick)="eventClick.emit($event)"></app-calendar-week>
    </ng-container>

    <!--MONTH-->
    <ng-container *ngSwitchCase="CalendarType.MONTH">
      <app-calendar-month #monthCalendar [date]="date" [eventHandler]="eventHandler" [dayTemplate]="monthDayTemplate" [settings]="monthSettings" (eventClick)="eventClick.emit($event)"></app-calendar-month>
    </ng-container>

    <!--YEAR-->
    <ng-container *ngSwitchCase="CalendarType.YEAR">
      <app-calendar-year #yearCalendar [date]="date" [eventHandler]="eventHandler" [dayTemplate]="yearDayTemplate" [settings]="yearSettings" (eventClick)="eventClick.emit($event)"></app-calendar-year>
    </ng-container>
  </ng-container>
</div>
